module.exports = __webpack_public_path__ + "static/img/red.bc4a2967.png";